export default __webpack_public_path__ + "static/media/agent-gold.20070668.svg";